const decided = new Set(['schedule_sent', 'interview_scheduled', 'interviewed', 'rejected', 'no_response']);
export const stageLabels = {
  review: 'Form Review', waiting: 'Exam · Waiting', completed: 'Exam · Completed',
  attention: 'Exam · Needs Attention', schedule_sent: 'Schedule sent',
  interview_scheduled: 'Interview scheduled', interviewed: 'Interviewed',
  rejected: 'Rejected', no_response: 'Closed · No response',
};

export function formStage(candidate, assessment) {
  if (!candidate) return 'unknown';
  if (decided.has(candidate.status)) return candidate.status;
  if (assessment) {
    if (['passed', 'failed'].includes(assessment.status)) return 'completed';
    // A failed first delivery must stay visible to the person reviewing forms.
    if (!assessment.last_sent_at) return 'review';
    if (['expired', 'send_failed'].includes(assessment.status)) return 'attention';
    return 'waiting';
  }
  if ((candidate.has_form_submission && !candidate.form_screening_override && candidate.status === 'form_submitted')
    || (candidate.form_screening_status === 'pending_hr_review' && !candidate.form_screening_override)) return 'review';
  return candidate.status;
}

export function buildFormWorkflow(candidates, submissions) {
  const byId = new Map(candidates.map(c => [c.id, c]));
  const history = submissions.map(s => ({ ...s,
    workflow_stage: formStage(byId.get(s.candidate_id), s.assessment),
  })).sort((a, b) => new Date(b.submitted_at) - new Date(a.submitted_at) || b.id - a.id);
  const seen = new Set();
  const latest = history.filter(s => {
    if (seen.has(s.candidate_id)) return false;
    seen.add(s.candidate_id);
    return true;
  });
  return { history, latest };
}
